import { create } from 'zustand';

import { ComparisonKeyImageSelectionStore } from './use-comparison-key-image-selection.model';

const INITIAL_COMPARISON_KEY_IMAGE_SELECTION_STATE = {
  hasKeyImageSelected: false,
  selectedKeyImage: null,
};

export const useComparisonKeyImageSelectionStore = create<ComparisonKeyImageSelectionStore>(
  (set) => ({
    ...INITIAL_COMPARISON_KEY_IMAGE_SELECTION_STATE,
    closeKeyImage: () => set({ hasKeyImageSelected: false, selectedKeyImage: null }),
    reset: () => set(INITIAL_COMPARISON_KEY_IMAGE_SELECTION_STATE),
    selectKeyImage: (selection) => set({ hasKeyImageSelected: true, selectedKeyImage: selection }),
  }),
);
